// extracted by mini-css-extract-plugin
export default {"selectFilters":"OCXuk","filterField":"tt1V1","gpuToggle":"SwNQl","propertyFilter":"jt7hh","greyText":"El2fD","unitText":"mPJX1","greenText":"liq_G","cardContent":"bSVnZ"};